const BASE_URL = 'https://api.jedediahs.com/'; // Dev Server
const BASE_URL_SOCKET_IO = 'https://socket.jedediahs.com/'; // Dev Server
const MAP_API_KEY = 'AIzaSyAxkrtgpkE60Mf4Y1B_W38eCqyoGTL5UcI';

const DEV_URL = 'https://shop.jedediahs.com/'
export {
    BASE_URL,
    BASE_URL_SOCKET_IO,
    MAP_API_KEY,
    DEV_URL,
}